
export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/admin/tiposUsuarios/store/state.js